import React, { useCallback, useState, useRef, useEffect } from 'react';
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
  Column,
  DataGrid,
  GroupPanel,
  Grouping,
  FilterRow,
  FilterPanel,
  Sorting,
  Paging,
  Selection,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
} from "devextreme-react/data-grid";
import { buildDxFilters, FormatPhoneNumber } from '../../../common/Utils'
import { IDCustomerLookupLayout } from '../../../common/lookups/Layouts/IdLayouts'
import { ID_TYPE_CUSTOMER } from '../../../const/constants'
import '../../../common/css/searchPage.css';

const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];

// Field factory for the search panel. Names match the CustomerMasterAddressDTO
// property names so the server-side filter resolves to the same columns as the grid.
const searchField = (name, label, type = "text", layout = null, tableName = "IDMASTER") => ({
  name,
  tableName: tableName,
  label,
  type,
  required: false,
  visible: true,
  isLabelChanged: false,
  ...(layout ? { layout } : {}),
});

// Search panel mirrors the grid columns one-to-one. Types drive buildDxFilters:
// text -> contains, select/number -> equals, datetime -> day range.
const SearchLayout = [
  {
    groupId: 1,
    fields: [
      searchField("ROWID", "Customer", "lookup", IDCustomerLookupLayout({ valueExpr: "id", displayExpr: "identityid" }), ""),
      searchField("NAME", "Name"),
      searchField("PROFILECODE", "Profile"),
      searchField("RECORD", "Record #"),
    ],
  },
  {
    groupId: 2,
    fields: [
      searchField("AddressADDRESSNAME", "Address Name"),
      searchField("AddressADDRESS1", "Address-1"),
      searchField("AddressADDRESS2", "Address - 2"),
      searchField("AddressCITY", "City"),
      searchField("AddressSTATE", "State"),
      searchField("AddressZIP", "Zip"),
      searchField("AddressCOUNTRY", "Country"),
      searchField("AddressCOUNTY", "County"),
      searchField("AddressMemo", "Address Memo"),
    ],
  },
  {
    groupId: 3,
    fields: [
      searchField("AddressTELEPHONE1", "Telephone"),
      searchField("AddressTELEPHONE2", "Telephone - 2"),
      searchField("AddressFAX1", "FAX"),
      searchField("AddressFAX2", "FAX - 2"),
      searchField("AddressCELLPHONE1", "CellPhone"),
      searchField("AddressCELLPHONE2", "CellPhone - 2"),
      searchField("AddressPAGER1", "Pager"),
      searchField("AddressPAGER2", "Pager - 2"),
      searchField("AddressMODEM1", "Modem"),
      searchField("AddressMODEM2", "Modem - 2"),
    ],
  },
  {
    groupId: 4,
    fields: [
      searchField("AddressEMAILADDRESS1", "E-Mail"),
      searchField("AddressEMAILADDRESS2", "E-Mail -2"),
      searchField("AddressWEBSITEADDRESS1", "WebSite"),
      searchField("AddressWEBSITEADDRESS2", "WebSite - 2"),
      searchField("REFERENCE1", "Reference 1"),
      searchField("REFERENCE2", "Reference 2"),
      searchField("ContactID", "Contact ID"),
      searchField("COMMENT", "Comment"),
    ],
  },
  {
    groupId: 5,
    fields: [
      searchField("CREATIONUSERID", "Created By"),
      searchField("CREATIONDATETIME", "Creation Date", "datetime"),
      searchField("LASTUPDATEUSERID", "Last Updated By"),
      searchField("LASTUPDATEDATETIME", "Last Updated", "datetime"),
      searchField("DATE1", "Date 1", "datetime"),
      searchField("DATE2", "Date 2", "datetime"),
    ],
  },
];

// Show only the first 2 fields of each of the first 4 groups (8 visible total);
// hide every other field, including all of group 5.
const VISIBLE_FIELDS_PER_GROUP = 2;
const VISIBLE_GROUP_COUNT = 4;
SearchLayout.forEach((group, groupIndex) => {
  group.fields.forEach((field, fieldIndex) => {
    field.visible = groupIndex < VISIBLE_GROUP_COUNT && fieldIndex < VISIBLE_FIELDS_PER_GROUP;
  });
});

/**
 * Shared "query by customer" landing page: a customer search panel over the
 * IDMASTER/address listing plus a View button that hands the selected customer's
 * rowid to a module-specific detail screen.
 *
 * Props:
 *   - title          : accordion heading (e.g. "Enter Your Query For Customer")
 *   - gridKey        : GUID used for grid state storage (must be unique per screen)
 *   - layoutId       : GUID for the dynamic-form layout of the search panel
 *   - layoutName     : dynamic-form layout name for the search panel
 *   - renderDetail   : (rowId, onBack) => node, rendered in place of the listing
 *                      once a customer is selected and View is clicked
 */
const CustomerQueryList = (props) => {
  const { title, gridKey, layoutId, layoutName, renderDetail } = props;
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  var currentUser = props.oidc.user;
  const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
  const formRefs = useRef({});
  const [selectedItems, setSelectedItems] = useState([]);
  const [isViewButtonDisabled, setIsViewButtonDisabled] = useState(true);
  const [viewRowId, setViewRowId] = useState(null);
  const rowId = useRef(null);

  const allowedPageSizes = [10, 20, 100, 500, 1000];
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken); }, [gridKey]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state); }, [gridKey]);
  const initialFormFields = {
    ROWID: '',
    NAME: '',
    PROFILECODE: '',
    RECORD: '',
    AddressADDRESSNAME: '',
    AddressADDRESS1: '',
    AddressADDRESS2: '',
    AddressCITY: '',
    AddressSTATE: '',
    AddressZIP: '',
    AddressCOUNTRY: '',
    AddressCOUNTY: '',
    AddressMemo: '',
    AddressTELEPHONE1: '',
    AddressTELEPHONE2: '',
    AddressFAX1: '',
    AddressFAX2: '',
    AddressCELLPHONE1: '',
    AddressCELLPHONE2: '',
    AddressPAGER1: '',
    AddressPAGER2: '',
    AddressMODEM1: '',
    AddressMODEM2: '',
    AddressEMAILADDRESS1: '',
    AddressEMAILADDRESS2: '',
    AddressWEBSITEADDRESS1: '',
    AddressWEBSITEADDRESS2: '',
    REFERENCE1: '',
    REFERENCE2: '',
    ContactID: '',
    COMMENT: '',
    CREATIONUSERID: '',
    CREATIONDATETIME: null,
    LASTUPDATEUSERID: '',
    LASTUPDATEDATETIME: null,
    DATE1: null,
    DATE2: null,
    AddressKEYSEQUENCE: '',
    COMPANYID: '',
    MODULE: '',
    RECORDTYPE: '',
    IDTYPE: ID_TYPE_CUSTOMER
  };
  const [formFields, setformFields] = useState(initialFormFields);
  const [resultData, setResultData] = useState(null);

  const onSelectionChanged = ({ selectedRowsData }) => {
    if (selectedRowsData && selectedRowsData.length === 1) {
      rowId.current = selectedRowsData[0].rowid;
      setIsViewButtonDisabled(false);
    } else {
      rowId.current = '';
      setIsViewButtonDisabled(true);
    }
  };

  const handleViewClick = () => {
    if (rowId.current) {
      setViewRowId(rowId.current);
    }
  };

  const selectionChanged = useCallback(
    (e, tg) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
    },
    [selectedItems, setSelectedItems],
  );

  const handleSearch = (e) => {
    e.event.stopPropagation();
    let datasource = loadDatasource();
    const { IDTYPE, ...filteredFormFields } = formFields;
    const filters = buildDxFilters(filteredFormFields, SearchLayout);
    if (filters && filters.length) {
      datasource.filter(filters);
    }
    setResultData(datasource);
  }

  const handleReset = (e) => {
    e.event.stopPropagation();
    setformFields(initialFormFields);
  }

  useEffect(() => {
    if (formFields.ROWID === '' && formFields.NAME === '' && formFields.REFERENCE1 === '' && formFields.REFERENCE2 === ''
      && formFields.AddressTELEPHONE1 === '' && formFields.PROFILECODE === ''
    )
      setResultData(loadDatasource);
  }, [formFields]);

  // No lookups in the search panel (Group/Subgroup removed); all fields are text/date.
  const handleFormLoad = useCallback(() => { }, []);

  const handleFieldChange = useCallback((name, value) => {
  }, []);

  const loadDatasource = () => {
    let store = createStore({
      key: 'rowid',
      // IncludeAllCustomers: this report lists every customer (no active-status filter),
      // unlike the shared Customer Data Entry page.
      loadParams: { ...formFields, IncludeAllCustomers: true },
      loadUrl: `${window._env_.REACT_APP_APIS}/${data.ID.GetCustomerData}`,
      onBeforeSend: (method, ajaxOptions) => {
        ajaxOptions.headers = {
          access_token: accessToken,
          Authorization: `Bearer ${accessToken}`,
        };
      },
    });
    const dataSource = new DataSource({ store: store });
    dataSource.sort([
      { selector: 'identityid', desc: false },
      { selector: 'keysequence', desc: false },
    ]);
    return dataSource;
  }

  if (viewRowId) {
    return renderDetail(viewRowId, () => setViewRowId(null));
  }

  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
          <AccordionReact
            dataSource={searchpanel}
            collapsible={true}
            multiple={false}
            animationDuration={300}
            selectedItems={selectedItems}
            onSelectionChanged={e => {
              if (e.currentTarget === e.target) {
                selectionChanged(e, e.target);
              }
            }}
            itemTitleRender={() => (
              <Toolbar className="accordian-toolbar">
                <Item location="before">
                  <div className="title">
                    <h6 style={{ color: window._env_.Color2 }}>
                      {title}
                    </h6>
                  </div>
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                </Item>
                <Item location="after">
                  <Button className="accordianButton" onClick={handleReset} text="Reset" />
                </Item>
              </Toolbar>
            )}
            itemRender={(itemProps) => (
              <FormField
                currrentUser={currentUser}
                layoutId={layoutId}
                layoutName={layoutName}
                defaultFormSchema={SearchLayout}
                formFields={formFields}
                setformFields={setformFields}
                handleFieldValueChange={handleFieldChange}
                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                formRefs={formRefs}
                onFormLoad={handleFormLoad}
                noSpacingBeforeFirstRow={true}
              />
            )}
            id="accordion-container" className="accordion-height"
          />
        </div>
        <div className="search-page-grid-container">
          <DataGrid
            onExporting={(e) => {
              if (window.handleDevExtremeDataGridExport) {
                window.handleDevExtremeDataGridExport(e);
              }
            }}
            ref={dataGrid}
            allowColumnReordering={true}
            allowColumnResizing={true}
            dataSource={resultData}
            showBorders={true}
            hoverStateEnabled={true}
            className="search-page-grid"
            onSelectionChanged={(e) => onSelectionChanged(e)}
            remoteOperations={true}
            searchEnabled={true}
            columnAutoWidth={true}
          >
            <ColumnChooser enabled={true} title="Choose Column" width={290} height={290} sortOrder="asc">
              <ColumnChooserSearch enabled={true} editorOptions={{ placeholder: 'Search column' }} />
            </ColumnChooser>
            <Export enabled={true} allowExportSelectedData={true} />
            <Selection mode="single" />
            <Sorting visible={true} mode="multiple" />
            <Paging defaultPageSize={10} />
            <Pager visible={true} showPageSizeSelector={true} allowedPageSizes={allowedPageSizes} showNavigationButtons={true} />
            <FilterRow visible={true} />
            <FilterPanel visible={true} />
            <GroupPanel visible={true} />
            <Grouping autoExpandAll={false} />
            <StateStoring enabled={true} type="custom" customLoad={loadState} storageKey={gridKey} customSave={saveState} />
            {/* Default-visible columns (match the desktop grid) */}
            <Column dataType="string" dataField="identityid" caption="Customer" defaultSortIndex={1} defaultSortOrder="asc" />
            <Column dataType="string" dataField="name" caption="Name" />
            <Column dataType="string" dataField="addressADDRESS1" caption="Address-1" />
            <Column dataType="string" dataField="addressADDRESS2" caption="Address - 2" />
            <Column dataType="string" dataField="addressCITY" caption="City" />
            <Column dataType="string" dataField="addressSTATE" caption="State" />
            <Column dataType="string" dataField="addressZIP" caption="Zip" />
            <Column dataType="string" dataField="addressTELEPHONE1" caption="Telephone" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column dataType="string" dataField="addressMemo" caption="Address Memo" />

            {/* Column-chooser columns (match the desktop chooser captions) */}
            <Column visible={false} dataType="string" dataField="addressADDRESSNAME" caption="Address Name" />
            <Column visible={false} dataType="string" dataField="addressCELLPHONE1" caption="CellPhone" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column visible={false} dataType="string" dataField="addressCELLPHONE2" caption="CellPhone - 2" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column visible={false} dataType="string" dataField="addressCOUNTRY" caption="Country" />
            <Column visible={false} dataType="string" dataField="creationuserid" caption="Created By" />
            <Column visible={false} dataType="datetime" dataField="creationdatetime" caption="Creation Date" />
            <Column visible={false} dataType="string" dataField="addressEMAILADDRESS1" caption="E-Mail" />
            <Column visible={false} dataType="string" dataField="addressEMAILADDRESS2" caption="E-Mail -2" />
            <Column visible={false} dataType="string" dataField="addressFAX1" caption="FAX" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column visible={false} dataType="string" dataField="addressFAX2" caption="FAX - 2" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column visible={false} dataType="datetime" dataField="lastupdatedatetime" caption="Last Updated" />
            <Column visible={false} dataType="string" dataField="lastupdateuserid" caption="Last Updated By" />
            <Column visible={false} dataType="string" dataField="addressMODEM1" caption="Modem" />
            <Column visible={false} dataType="string" dataField="addressMODEM2" caption="Modem - 2" />
            <Column visible={false} dataType="string" dataField="addressPAGER1" caption="Pager" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column visible={false} dataType="string" dataField="addressPAGER2" caption="Pager - 2" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column visible={false} dataType="string" dataField="profilecode" caption="Profile" />
            <Column visible={false} dataType="string" dataField="record" caption="Record #" />
            <Column visible={false} dataType="string" dataField="addressTELEPHONE2" caption="Telephone - 2" cellRender={cellData => <div>{FormatPhoneNumber(cellData.value)}</div>} />
            <Column visible={false} dataType="string" dataField="addressWEBSITEADDRESS1" caption="WebSite" />
            <Column visible={false} dataType="string" dataField="addressWEBSITEADDRESS2" caption="WebSite - 2" />

            {/* Additional (non-desktop) technical columns, kept hidden */}
            <Column visible={false} dataType="string" dataField="companyid" caption="Company ID" />
            <Column visible={false} dataType="string" dataField="module" caption="Module" />
            <Column visible={false} dataType="string" dataField="recordtype" caption="Record Type" />
            <Column visible={false} dataType="string" dataField="idgroup" caption="Group" />
            <Column visible={false} dataType="string" dataField="idsubgroup" caption="Subgroup" />
            <Column visible={false} dataType="string" dataField="referencE1" caption="Reference 1" />
            <Column visible={false} dataType="string" dataField="referencE2" caption="Reference 2" />
            <Column visible={false} dataType="datetime" dataField="date1" caption="Date 1" />
            <Column visible={false} dataType="datetime" dataField="date2" caption="Date 2" />
            <Column visible={false} dataType="string" dataField="comment" caption="Comment" />
            <Column visible={false} dataType="string" dataField="addressCOUNTY" caption="County" />
            <Column visible={false} dataType="string" dataField="contactID" caption="Contact ID" />
            <GridToolbar>
              <GridToolbarItem location="before">
                <Button
                  disabled={isViewButtonDisabled}
                  onClick={handleViewClick}
                  type="default"
                  text="View"
                />
              </GridToolbarItem>
              <GridToolbarItem name="exportButton" />
              <GridToolbarItem name="columnChooserButton" />
            </GridToolbar>
          </DataGrid>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    oidc: state.oidc
  };
}
export default connect(mapStateToProps)(CustomerQueryList);
